import React, {useEffect, useState} from 'react';
import ProductsManager from "../managers/productsManager/productsManager";
import Grid from "@mui/material/Grid2";
import {CardContent, Typography} from "@mui/material";
import {Trans} from "react-i18next";
import OrderDesigns from "../user/userPage/components/OrderDesigns";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {Link, useNavigate} from "react-router";
import {deleteDoc, doc, getFirestore, updateDoc} from "firebase/firestore";
import app from "../firebaseConfig/firebaseConfig";

const db = getFirestore(app);

function ProductsEditor() {
    const [products, setProducts] = useState();
    const navigate = useNavigate();
    const fetchData = async () => {
        const data = await ProductsManager.getAllProducts(true);
        setProducts({...data});
    };

    useEffect(() => {
        fetchData();
    }, []);

    const getImages = (product) => {
        if (product.images.length) {
            return <Link to={`/products/${product.id}`}><OrderDesigns images={[product.images[0]]}/></Link>;
        }

        return '';
    }

    const deleteProduct = async (id) => {
        await deleteDoc((doc(db, 'products', id)));
        fetchData();
    }

    const disableProduct = async (id) => {
        await updateDoc((doc(db, 'products', id)), {disabled: true});
        fetchData();
    }

    const enableProduct = async (id) => {
        await updateDoc((doc(db, 'products', id)), {disabled: false});
        fetchData();
    }

    const cloneProduct = (id) => {
        navigate(`clone-product-${id}`)
    }

    return (products &&
        <div className="producteditor">
            <Button sx={{mt: 2}} color={'secondary'} onClick={() => navigate('/admin')}>&lt; <Trans i18nKey={'buttons.back'}/></Button>
            <Box p={2}>
                <Button variant={"outlined"} onClick={() => navigate('new-product')}>Add new</Button>
            </Box>
            {Object.keys(products).map(key => <CardContent key={key} sx={{
                pt: 0,
                filter: (products[key].disabled ? 'grayscale(1)' : '')
            }}>
                <Grid container>
                    <Grid flexGrow={1}>
                        <Typography variant="body1">
                            <Trans i18nKey={products[key].name}/> ({products[key].price} Lei)
                        </Typography>
                    </Grid>
                </Grid>
                {getImages(products[key])}

                <Box pt={2}>
                    <Button variant={"outlined"} onClick={() => navigate(key)}>Edit</Button>
                    <Button variant={"outlined"} onClick={() => deleteProduct(key)}>Delete</Button>
                    <Button variant={"outlined"} onClick={() => cloneProduct(key)}>Clone</Button>
                    {products[key].disabled ?
                        <Button variant={"outlined"} onClick={() => enableProduct(key)}>Enable</Button> :
                        <Button variant={"outlined"} onClick={() => disableProduct(key)}>Disable</Button>}
                </Box>
            </CardContent>)}
        </div>
    );
}

export default ProductsEditor;
